import { TableParams, type TableParamsType } from '../../types/common';
import { type UseQueryResult, useQuery } from 'react-query';
import {
  EsppPurchasePeriodService,
  PagedResultDto_EsppPurchasePeriodParticipantResult,
} from '../../services/wealthlane-award-services';

const useGetEsppParticipants = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  offeringPeriodId: string,
  purchasePeriodId: string,
  tableInfo: TableParams
): UseQueryResult<
  // eslint-disable-next-line
  PagedResultDto_EsppPurchasePeriodParticipantResult | undefined,
  unknown
> => {
  const {
    eligibilityStatus,
    enrollmentStatus,
    enrolledStatus,
    emailStatus,
    filter,
    sorting,
    skipCount,
    maxResultCount,
  } = tableInfo;
  const esppParticipantsList = useQuery(
    [
      'getEsppParticipants',
      offeringPeriodId,
      purchasePeriodId,
      eligibilityStatus,
      enrollmentStatus,
      enrolledStatus,
      emailStatus,
      filter,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      return await handleRequest(
        EsppPurchasePeriodService.getApiAwardApiAwardOfferingPeriodPurchasePeriodEsppParticipants(
          offeringPeriodId as string,
          purchasePeriodId as string,
          eligibilityStatus,
          enrollmentStatus,
          enrolledStatus,
          emailStatus,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return esppParticipantsList;
};

export default useGetEsppParticipants;
